import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import GetBusinessPartnerInfo from "./BusinessPartner/Infrastructure/BusinessPartner.presenter";
import { getUserModel } from "./User/Infrastructure/User.reducer";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "./App.css";
import { Amplify, Auth, API, graphqlOperation } from "aws-amplify";
import Navbar from "./DesignSystem/Navbar";
import Login from "./Auth/UI/Login.ui";
import BusinessList from "./Business/UI/BusinessList.ui";
import UsersChatList from "./User/UI/UsersChatList.ui";
import BusinessInfo from "./Business/UI/BusinessInfo.ui";
import BusinessCommentsList from "./Business/UI/BusinessCommentsList.ui";
import UserRegisterUI from "./User/UI/UserRegister.ui";
import AdviserProfile from "./Adviser/UI/AdviserProfile.ui";
import BusinessCommissions from "./Business/UI/BusinessCommissions.ui";
import awsconfig from "./aws-exports";

import TabMenu from "./DesignSystem/TabMenu";
import Chat from "./Chat/UI/Chat.ui";

import UserProfile from "./User/UI/UserProfile.ui";
import MobileMap from "./DesignSystem/MobileMap";
import BusinessProductsOffers from "./DesignSystem/BusinessProductOffers";

import Choose from "./User/UI/choosemethod";
import RegisterCard from "./User/UI/formcard/registercard";
import RegisterCLABE from "./User/UI/formcard/registerClabe";
Amplify.configure(awsconfig);

function App() {
  const idUser = useSelector(getUserModel);

  useEffect(() => {
    
    if (idUser) {
      GetBusinessPartnerInfo(idUser);
    } else {
      GetBusinessPartnerInfo(
        localStorage.getItem(
          "CognitoIdentityServiceProvider.10th6r5fgst4ihbf0gvpelpbjf.LastAuthUser"
        )
      );
    }
  }, [idUser]);

  // async function ConfirmSignup() {

  //   try {
  //     const username = '6393620f-d948-46a2-811d-97c3c29e7ac0'; // user id
  //     const code = '012345'; 
  //     const response = await Auth.confirmSignUp(username, code);
  //     console.log(response);
  //   } catch (error) {
  //       console.log('error confirming sign up', error);
  //   }
  // } 

  //TODO: Actualizar el registro de un usuario
  // useEffect(() => {
  //   UpdateAccountOne();
  // }, []);

  // async function UpdateAccountOne() {

  //   try {
  //     const username = 'cf788fd4-3884-4d83-a510-8f6463306e33'; // user id
  //     const role = 'afiliador';
  //     const birthday = new Date('1999-09-12').toISOString();
  //     const zone = 'yak9vgsa-v34f-v34f-9858-mptj8bdgxxd2';

  //     const response = await API.graphql(
  //       graphqlOperation(updateAccountOne, {input: {
  //         id: username,
  //         role: role,
  //         birthday: birthday,
  //         zone: zone,
  //       }})
  //     );
  //     console.log(response);
  //   } catch (error) {
  //       console.log('error ', error);
  //   }
  // } 

  /*
  //Calcular ganancias por tienda
  async function calculateProfitByShop(){
    const id = 'fe601320-56e1-4d6e-942f-6e5996d7bb9b';
    const dates = ['2021-11-01T12:00:00.958Z', '2022-03-01T24:00:00.958Z'];
    const items = [];

    try {
      const response = await API.graphql({
        query: GetAllFinalizedOrdersByShop,
        variables: {
          id: id,
          betweenDates: dates
        }
      });

      let category = response['data']['getShop']['category']
      var percentageByCategory = 0.06;
      if(category === 'Restaurantes'){
        percentageByCategory = 0.08;
      }else if(category === 'Gas'){
        percentageByCategory = 0.01;
      }

      let shop_name = response['data']['getShop']['shop_name']
      let cont = 0;
      response['data']['getShop']['orders']['items'].forEach( order => {
        let subtotal = order['total'] - order['discount']; 
        let nikuComission = subtotal * percentageByCategory; //NikuComission
        let sendComission = order['com_shop'] + order['com_customer']; //Comisión de envio
        let ids = order['id']
        const myJson = { 
          "Negocio": shop_name, 
          "Orden": ids.slice(0, 6), 
          "ComisionEnvio": sendComission, 
          "ComisionNiku": nikuComission, 
          "Total": order['final_total']
        };

        items[cont] = myJson;
        cont++;
      });
      //return items;
      console.log(items);
    } catch (error) {
      console.log(error);
    }
  }
  */

  // useEffect(() => {
  //   const params = {
  //     id: 'e83d7dba-a598-416c-a359-bcfe1bdd1977',
  //     dates: ['2022-01-01T00:00:00Z', '2022-01-31T23:59:59Z'],
  //   };

  //   console.log(calculateProfitByZone(params));
  // },[]);

  // // TODO: Calcular ganacias por zona
  // async function calculateProfitByZone({id,dates}){
  //   let profit = 0;
  //   try {
  //     const response = await API.graphql({ 
  //         query: GetAllFinalizedOrdersByZone, 
  //         variables: { 
  //         zone_id: id, 
  //         betweenDates: dates 
  //       }
  //     });
  //     response['data']['listShops']['items'].forEach( shop => {
  //       let category = shop['category'];
  //       let percentageByCategory = 0.06;
  //       if(category === 'Restaurantes'){
  //         percentageByCategory = 0.08;
  //       }else if(category === 'Gas'){
  //         percentageByCategory = 0.01;
  //       }
  //       shop['orders']['items'].forEach( order => {
  //         let subtotal = order['total'] - order['discount'];
  //         let nikuComission = subtotal * percentageByCategory;
  //         profit = profit + order['com_shop'] + order['com_customer'] + (nikuComission*0.5);
  //       });
  //     });
  //     return profit;
  //   } catch (error) {
  //       console.log(error);
  //     }
  // }

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Login />
        </Route>

        <PrivateRoute exact path="/negocios">
          <BusinessList />
        </PrivateRoute>

        <PrivateRoute exact path="/negocio/:id">
          <BusinessInfo />
        </PrivateRoute>

        <PrivateRoute exact path="/negocio/:id/comentarios">
          <BusinessCommentsList />
        </PrivateRoute>

        <PrivateRoute exact path="/negocio/:id/ubicacion">
          <MobileMap />
        </PrivateRoute>

        <PrivateRoute exact path="/negocio/:id/productos">
          <BusinessProductsOffers />
        </PrivateRoute>

        <PrivateRoute exact path="/register/:roleUser">
          <UserRegisterUI />
        </PrivateRoute>

        <PrivateRoute exact path="/perfil">
          <UserProfile />
        </PrivateRoute>

        <PrivateRoute exact path="/elegir">
          <Choose />
        </PrivateRoute>
        
        <PrivateRoute exact path="/registrotarjeta">
          <RegisterCard />
        </PrivateRoute>
        <PrivateRoute exact path="/registroCLABE">
          <RegisterCLABE />
        </PrivateRoute>

        <PrivateRoute exact path="/inicio">
          <AdviserProfile />
        </PrivateRoute>

        <PrivateRoute exact path="/personal/repartidores">
          <UsersChatList role="delivery" />
        </PrivateRoute>

        <PrivateRoute exact path="/personal/asesores">
          <UsersChatList role="adviser" />
        </PrivateRoute>

        <PrivateRoute exact path="/reportes/comisiones">
          <BusinessCommissions />
        </PrivateRoute>

        <PrivateRoute exact path="/chat">
          <Chat />
        </PrivateRoute>
        <PrivateRoute exact path="/chat/:id">
          <Chat />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}

export default App;

export function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !localStorage.getItem(
          "CognitoIdentityServiceProvider.10th6r5fgst4ihbf0gvpelpbjf.LastAuthUser"
        ) ? (
          <Redirect
            to={{
              pathname: `/`,
              state: { from: location },
            }}
          />
        ) : (
          <>
            <Navbar />
            <TabMenu />
            {children}
          </>
        )
      }
    />
  );
}
